import { render, staticRenderFns } from "./kargoRapor.vue?vue&type=template&id=636d4c6f&"
import script from "./kargoRapor.vue?vue&type=script&lang=js&"
export * from "./kargoRapor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports